module.exports = __webpack_public_path__ + "img/feature08.9d79481.png";